import { EnrollmentStatusEnum } from '@/types/composition-functions';

export interface EnrollmentStatusOption {
  label: string;
  value: EnrollmentStatusEnum;
}

// PROMOTED is intentionally excluded from the filter UI — it's a closed-record
// state, not a current student status, so filtering on it returns the same set
// as ENROLLED (every student promoted from a prior term). The enum value is
// still recognised on the wire for backend state-machine integrity.
export const ENROLLMENT_STATUS_OPTIONS: EnrollmentStatusOption[] = [
  { label: 'Enrolled', value: EnrollmentStatusEnum.Enrolled },
  { label: 'Graduated', value: EnrollmentStatusEnum.Graduated },
  { label: 'Suspended', value: EnrollmentStatusEnum.Suspended },
  { label: 'Withdrawn', value: EnrollmentStatusEnum.Withdrawn },
  { label: 'Transferred', value: EnrollmentStatusEnum.Transferred },
  { label: 'Expelled', value: EnrollmentStatusEnum.Expelled },
  { label: 'Left', value: EnrollmentStatusEnum.Left },
];

const STATUS_SEVERITY: Record<EnrollmentStatusEnum, string> = {
  [EnrollmentStatusEnum.Enrolled]: 'success',
  [EnrollmentStatusEnum.Promoted]: 'success',
  [EnrollmentStatusEnum.Graduated]: 'info',
  [EnrollmentStatusEnum.Suspended]: 'warn',
  [EnrollmentStatusEnum.Withdrawn]: 'danger',
  [EnrollmentStatusEnum.Transferred]: 'secondary',
  [EnrollmentStatusEnum.Expelled]: 'danger',
  [EnrollmentStatusEnum.Left]: 'secondary',
};

export function enrollmentStatusSeverity(status: EnrollmentStatusEnum | string | null | undefined): string {
  if (!status) return 'secondary';
  return STATUS_SEVERITY[status as EnrollmentStatusEnum] ?? 'secondary';
}

export function enrollmentStatusLabel(status: EnrollmentStatusEnum | string | null | undefined): string {
  if (!status) return '—';
  const match = ENROLLMENT_STATUS_OPTIONS.find(o => o.value === status);
  return match?.label ?? String(status);
}
